import {
  Button,
  Div,
  H3,
  Modal,
  P,
  PropsModal,
  lightTheme,
} from '@vgrubs/components';

export const MarkOrderAsCompletedModal = ({
  modalIsOpen,
  closeModal,
  handleMarkAsCompleted,
}: PropsModal & {
  handleMarkAsCompleted: () => void;
  modalIsOpen: boolean;
}) => {
  return (
    <Modal isOpen={modalIsOpen} closeModal={closeModal} logo={false}>
      <H3 $mb="10" $color={lightTheme.primary}>
        Are you sure
      </H3>
      <P $mb="24">Are you sure you want to mark this order as completed?</P>

      <Div $flex $gap="16px">
        <Button $selected $w="100%" $gray onClick={closeModal}>
          Cancel
        </Button>
        <Button $selected $w="100%" onClick={handleMarkAsCompleted}>
          Confirm
        </Button>
      </Div>
    </Modal>
  );
};
